import Footer from '../commons/Footer'
import Navbar from '../commons/Navbar'

import breadcrumbshape1 from '../img/breadcrumb/breadcrumb-shape-1.png'
import breadcrumbshape2 from '../img/breadcrumb/breadcrumb-shape-2.png'
import breadcrumbsub1 from '../img/breadcrumb/breadcrumb-sub-1.png'

const TermsAndConditions = () => {
  return (
    <div>
      {/* tp-offcanvus-area-start */}

      <div className="body-overlay" />
      {/* tp-offcanvus-area-end */}
      <Navbar />
      <div id="smooth-wrapper">
        <div id="smooth-content">
          <main>
            {/* breadcrumb-area-start */}
            <div className="breadcrumb__area breadcrumb-height p-relative blue-bg-2">
              <div className="breadcrumb__shape-1">
                <img src={breadcrumbshape1} alt="" />
              </div>
              <div className="breadcrumb__shape-2">
                <img src={breadcrumbshape2} alt="" />
              </div>
              <div className="container">
                <div className="row">
                  <div className="col-xl-8 col-lg-7">
                    <div className="breadcrumb__content">
                      <h5 className="breadcrumb__title tp-char-animation">
                        Terms And Conditions
                      </h5>
                      <div className="breadcrumb__list tp-title-anim">
                        <span className="child-one">
                          <a
                            href="/"
                            style={{ textDecoration: 'none', color: 'white' }}
                          >
                            Home
                          </a>
                        </span>
                        <span className="dvdr">
                          <i className="fal fa-angle-right" />
                        </span>
                        <span className="dvdr">
                        </span>
                        <span>TermsAndConditions</span>
                      </div>
                    </div>
                  </div>
                  <div className="col-xl-4 col-lg-5 col-lg-4 text-center text-md-end">
                    <div className="breadcrumb__img p-relative text-start z-index">
                      <div
                        className="breadcrumb__sub-img wow tpfadeUp"
                        data-wow-duration=".9s"
                        data-wow-delay=".4s"
                      >
                        <img src={breadcrumbsub1} alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* breadcrumb-area-end */}
            {/* service-details-area-start */}
             <div className="bg-white text-black min-h-screen flex justify-center items-start py-10 px-4">
  <div className="w-full max-w-5xl break-words">
    <h1 className="text-3xl font-bold mb-6">Terms and Conditions for LONO Services</h1>

    <p className="mb-5">
      These terms and conditions govern your use of the finance technology services provided by
      LONO (Busicon Services Private Limited), registered in Central Registration Centre, Telangana.
      By accessing or using our Services, you agree to be bound by these Terms.
    </p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">1. Acceptance of Terms</h5>
    <p className="mb-4">
      By accessing or using the Services, you agree to comply with these Terms and any additional
      terms and conditions that may apply.
    </p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">2. Description of Services</h5>
    <p className="mb-4">
      LONO offers services like finance, tax compliance, legal support, business management, and
      may include more in the future (e.g., investment, payment processing).
    </p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">3. User Accounts</h5>
    <ul className="list-disc list-inside mb-4">
      <li>Provide accurate and up-to-date information.</li>
      <li>Maintain confidentiality of your credentials.</li>
      <li>Notify LONO of any unauthorized use of your account.</li>
    </ul>

    <h5 className="text-2xl font-semibold mt-6 mb-2">4. User Conduct</h5>
    <p className="mb-2">You agree not to:</p>
    <ul className="list-disc list-inside mb-4">
      <li>Violate laws or engage in unlawful activities.</li>
      <li>Transmit malicious software.</li>
      <li>Disrupt or attempt unauthorized access to systems.</li>
    </ul>

    <h5 className="text-2xl font-semibold mt-6 mb-2">5. Fees and Payment</h5>
    <p className="mb-4">
      You agree to pay all applicable fees. LONO may change its fee structure with notice.
    </p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">6. Intellectual Property</h5>
    <p className="mb-4">
      All content is the property of LONO and is protected by copyright and trademark laws. You
      receive a non-transferable license for personal use only.
    </p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">7. Privacy</h5>
    <p className="mb-4">Use of services is subject to the LONO Privacy Policy.</p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">8. Disclaimer of Warranties</h5>
    <p className="mb-4">
      Services are provided "as is" without warranties. No guarantees of uninterrupted or error-free
      service.
    </p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">9. Limitation of Liability</h5>
    <p className="mb-4">
      LONO is not liable for indirect, incidental, or consequential damages.
    </p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">10. Governing Law and Jurisdiction</h5>
    <p className="mb-4">These Terms are governed by laws of the Central Registration Centre.</p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">11. Changes to Terms</h5>
    <p className="mb-4">LONO may modify these Terms with 30 days’ notice for material changes.</p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">12. Contact Us</h5>
    <p className="mb-4">
      Email: <a href="mailto:help@lono.org.in" className="text-blue-600 underline">help@lono.org.in</a><br />
      Website: <a href="https://lono.co.in" target="_blank" rel="noopener noreferrer" className="text-blue-600 underline">lono.co.in</a><br />
      Mobile: +91 765 893 4523
    </p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">13. Termination</h5>
    <p className="mb-4">
      LONO may suspend or terminate access without notice. All rights cease immediately upon
      termination.
    </p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">14. Data Security</h5>
    <p className="mb-4">
      While industry-standard security is employed, you acknowledge that no online method is
      100% secure.
    </p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">15. Compliance with Laws</h5>
    <p className="mb-4">
      You must comply with laws related to data protection, financial regulations, and AML.
    </p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">16. Indemnification</h5>
    <p className="mb-4">
      You agree to indemnify and hold LONO and its team harmless from claims arising from
      misuse or legal violations.
    </p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">17. Dispute Resolution</h5>
    <p className="mb-4">
      Disputes will be resolved through arbitration, and the award may be enforced by courts.
    </p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">18. No Waiver</h5>
    <p className="mb-4">
      Failure to enforce any right under these terms is not a waiver of those rights.
    </p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">19. Entire Agreement</h5>
    <p className="mb-4">
      These Terms are the entire agreement between you and LONO regarding the Services.
    </p>

    <h5 className="text-2xl font-semibold mt-6 mb-2">20. Severability</h5>
    <p className="mb-4">
      If any part of these Terms is held invalid, the remaining parts will still be enforceable.
    </p>
  </div>
            </div>
            {/* service-details-area-end */}
          </main>
          <Footer />
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
